<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="463" height="92" viewBox="0 0 463 92" preserveAspectRatio="">
    <defs>
      <clipPath id="clip-Web_1920_1">
        <rect width="463" height="92"/>
      </clipPath>
    </defs>
    <g id="Web_1920_1" clip-path="url(#clip-Web_1920_1)">
      <path id="Differenzmenge_2" d="M491,92H28V37.5A16,16,0,0,1,43.765,21.532H387.427s.116,0,2.062,0l5.065,0h.022c6.894,0,12.081-2.263,17.9-7.808l.015-.014.032-.03A46.423,46.423,0,0,1,419.46,8,47.586,47.586,0,0,1,480.2,14.449a27.947,27.947,0,0,0,7.945,5.332,23.064,23.064,0,0,0,9.181,1.75h.02l5.065,0c1.947,0,2.059,0,2.061,0l-8.811,1.127.961,6.1L491,29.791v2.892a45.343,45.343,0,0,1,0,26.635V92Z" transform="translate(-28 0)" fill="#fff"/>
    </g>
  </svg>
</template>

<script>
export default {
name: "bg"
}
</script>

<style scoped>

</style>